export default __webpack_public_path__ + "static/media/naman.3c36dae6.jpeg";